import React, { useEffect, useState, useRef, useMemo } from "react";
import style from "../styles.module.scss";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { useSelector, useDispatch } from "react-redux";
import axios from 'util/axios';

import Row from "../datatable/DataTable";

import { useTranslation } from "react-i18next";

import update from "immutability-helper";

import ModalPortal from "util/component/Modal";
import { ConfirmWithMessage, Modal } from "util/component/Modal/Modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpWideShort, faArrowDownWideShort } from "@fortawesome/free-solid-svg-icons";

const post = async ({ api, body, message }, getFunc, onError) => {
    const response = await axios.post(process.env.REACT_APP_API + api, {...body, message});
    if (response.status.toString() === "200") {
        if (response.data.data.result?.toString().includes("ERR")) {
            onError(response.data.data.result.toString());
        } else {
            getFunc && getFunc();
        }
    } else {
        onError("Server Code : " + response.status.toString());
    }
};

const FilterInitial = { stepCd: "", paraCd: "", paraNm: "", paraDesc: "" };

const ParaInTable = () => {
    const { t } = useTranslation(["page"]);
    const user = useSelector((store) => store.user);
    const mTable = useSelector((store) => store.masterTable);
    const dispatch = useDispatch();

    const [TableData, SetTableData] = useState([]);
    const [MoveAble, SetMoveAble] = useState(false);

    const [NewParam, SetNewParam] = useState({ paraCd: "", paraNm: "", paraDesc: "" });

    const ModalMessage = useRef(null);
    const tempData = useRef(null);

    const rendering = !!mTable.proc && mTable.proc.match(/(USP|DSP)/) && mTable.subtype === "IN";
    const [ModalOpen, SetModalOpen] = useState(false);

    const thColSpan = useRef(6);

    const [Filter, SetFilter] = useState(FilterInitial);
    const [OrderBy, SetOrderBy] = useState(null);

    const onError = (message) => {
        ModalMessage.current = t(message);
        SetModalOpen("modal");
    };

    const getData = async () => {
        SetModalOpen(false);
        const response = await axios.post(process.env.REACT_APP_API + "/common/retrieveParaInList", {
            groupCd: mTable.proc,
            unitOpCd: mTable.uo,
            stepCd: mTable.step,
        });
        const data = response.data.data.result;

        SetNewParam({ paraCd: "", paraNm: "", paraDesc: "" });
        SetMoveAble(false);
        if(!!OrderBy?.name || Object.keys(Filter)?.filter((e) => !!Filter[e]).length > 0) {
            filterAndOrderBy(data);
        } else {
            SetTableData(data);
        }
    };

    const action = (args) => {
        const { type } = args;
        switch (type.toString().toLowerCase()) {
            case "change":
                SetTableData((d) =>
                    update(d, {
                        [args.index]: { $set: { ...d[args.index], ...{ [args.name]: args.value.toString().trim(), isUpdate: true } } },
                    })
                );
                break;
            case "move":
                SetTableData((d) =>
                    update(d, {
                        $splice: [
                            [args.dragIndex, 1],
                            [args.hoverIndex, 0, d[args.dragIndex]],
                        ],
                    })
                );
                SetMoveAble(true);
                break;
            case "select":
                dispatch({ type: "setMasterParaCd", paraCd: TableData[args.index].paraCd });
                const fi = TableData.findIndex((v) => v.selected);
                SetTableData((d) =>
                    update(d, {
                        [fi]: { $set: { ...d[fi], selected: false } },
                        [args.index]: { $set: { ...d[args.index], selected: true } },
                    })
                );
                break;
            case "updatecomplete":
                SetTableData((d) => {
                    const next = update(d, {
                        [args.index]: { $set: { ...d[args.index], isUpdate: false } },
                    });
                    tempData.current = {
                        api: "/common/modifyParaCodeNm",
                        body: {
                            stepCd: next[args.index].stepCd,
                            paraCd: next[args.index].paraCd,
                            paraNm: next[args.index].paraNm,
                            paraDesc: next[args.index].paraDesc,
                            userId: user.userId,
                        },
                    };
                    ModalMessage.current = t("modifyConfirm");
                    SetModalOpen("confirm");
                    return next;
                });
                break;
            case "disable":
                tempData.current = {
                    api: "/common/modifyParaCodeDisableYn",
                    body: {
                        stepCd: TableData[args.index].stepCd,
                        paraCd: TableData[args.index].paraCd,
                        disableYn: TableData[args.index].disableYn === "N" ? "Y" : "N",
                        userId: user.userId,
                    },
                };
                ModalMessage.current = t("statusConfirm");
                SetModalOpen("confirm");
                break;
            default:
                console.error("No type [" + type + "]");
        }
    };

    const insertMasterCode = () => {
        const { paraCd, paraNm, paraDesc } = NewParam;
        if (!!!paraCd || !!!paraNm || !!!paraDesc) {
            ModalMessage.current = t("emptyConfirm");
            SetModalOpen("modal");
        } else {
            let orderBy;
            try {
                if (TableData.length < 2) {
                    orderBy = TableData.length + 1;
                } else {
                    const orderByNum = TableData.reduce((prev, value) => {
                        return prev.orderBy >= value.orderBy ? prev.orderBy : value.orderBy;
                    });
                    orderBy = parseInt(orderByNum) + 1;
                }
            } catch (e) {
                orderBy = 1;
            }

            tempData.current = {
                api: "/common/createParaCode",
                body: {
                    stepCd: mTable.step,
                    paraCd,
                    paraType: mTable.subtype,
                    paraNm,
                    paraDesc,
                    orderBy,
                    userId: user.userId,
                },
            };
            ModalMessage.current = t("addConfirm");
            SetModalOpen("confirm");
        }
    };

    const setOrderBy = () => {
        let newD = TableData.map((v, i) => {
            return {
                stepCd: v.stepCd,
                paraCd: v.paraCd,
                orderBy: i + 1,
                userId: user.userId,
            };
        });
        tempData.current = {
            api: "/common/modifyParaCodeOrderBy",
            body: { master: newD },
        };
        ModalMessage.current = t("ChangeOrderConfirm");
        SetModalOpen("confirm");
    };

    const renderTable = useMemo(() => {
        let targetColumn = [
            { col: "orderBy", disabled: !!!mTable.step },
            { col: "processCd", readOnly: true, selectAble: true, textAlign: "center" },
        ];

        if (!!mTable.uo) targetColumn = [...targetColumn, { col: "unitOpNm", readOnly: true, selectAble: true }];
        if (!!mTable.step) targetColumn = [...targetColumn, { col: "stepNm", readOnly: true, selectAble: true }];

        targetColumn = [...targetColumn, { col: "paraCd", readOnly: true, selectAble: true }, { col: "paraNm" }, { col: "paraDesc" }];
        const disabled = !!OrderBy?.name || Object.keys(Filter)?.filter((e) => !!Filter[e]).length > 0;
        const row = TableData.map((v, i) => {
            return <Row key={"paraInTable" + i} hide={v?.hide} disabled={user.isAdmin ? disabled : true} index={i} rowData={v} targetCol={targetColumn} action={action} admin={user.isAdmin} />;
        });
        return row;
    }, [TableData]);

    // Filter, OrderBy 변경
    useEffect(() => {
        filterAndOrderBy();
    },[Filter, OrderBy])

    const filterAndOrderBy = (d) => {
        let data;
        TableData.map(data=>{
            if(data.hide){
                data.hide = false;
            }
        })
        if(!!d) {
            data = d;
        } else {
            data = [...TableData];
        }

        if (!!OrderBy?.name) {
            data = data.sort((prev, next) => {
                if (prev[OrderBy.name] > next[OrderBy.name]) return 1;
                if (prev[OrderBy.name] < next[OrderBy.name]) return -1;
                return 0;
            });
            if (OrderBy.type === "DESC") {
                data = data.reverse();
            }
        } else {
            data = data.sort((prev, next) => {
                if (prev.orderBy > next.orderBy) return 1;
                if (prev.orderBy < next.orderBy) return -1;
                return 0;
            });
        }
        Object.keys(Filter).forEach((str) => {
            
                data = data.map((e) => {
                    if(e[str].toString().toLowerCase().includes(Filter[str]?.toString().toLowerCase())&& !e.hide) {
                        return {...e, hide: false}
                    } else {
                        return {...e, hide: true}
                    }
                    
                });
            
        });
        SetTableData(data);
    }

    useEffect(() => {
        if (rendering) getData();
/*        thColSpan.current = 6;
        if (!!mTable.uo) thColSpan.current = 7;
        if (!!mTable.step) thColSpan.current = 8;*/
        return () => {
            SetTableData([]);
            SetMoveAble(false);
        };
    }, [mTable.proc, mTable.uo, mTable.step, rendering]);

    const fnThColSpan = () =>{
        thColSpan.current = 6;
        if (!!mTable.uo) thColSpan.current = 7;
        if (!!mTable.step) thColSpan.current = 8;
        if(!user.isAdmin) thColSpan.current--;
        return thColSpan.current;
    }
    const ModalRender = useMemo(() => {
        const confirmValid = () => {
            return true;
        };
        const onConfirm = async (message) => {
            await post({...tempData.current, message}, getData, onError);
        };
        if (!ModalOpen) {
            tempData.current = null;
            return null;
        } else {
            if (ModalOpen === "confirm") {
                return (
                    <ConfirmWithMessage onClose={() => SetModalOpen(false)} valid={confirmValid} onConfirm={(message) => onConfirm(message)}>
                        <p>{ModalMessage.current}</p>
                    </ConfirmWithMessage>
                );
            } else {
                return <Modal onClose={() => SetModalOpen(false)}>{ModalMessage.current}</Modal>;
            }
        }
    }, [ModalOpen]);

    const changeOrderby = (e) => {
        const dtype = e.target.dataset.type;
        let ord;
        if (dtype === OrderBy?.name) {
            ord = OrderBy?.type === "DESC" ? "ASC" : "DESC";
        } else {
            ord = "DESC";
        }
        SetOrderBy({ name: dtype, type: ord });
    };

    if (!rendering) {
        return null;
    } else {
        return (
            <section>
                <div className={`${style.mainTable}`}>
                    <DndProvider backend={HTML5Backend}>
                        <table style={{ width: "100%" }}>
                            <colgroup>
                                <col width="50px" />
                                <col width="60px" />
                                {!!mTable.uo && <col width="90px" />}
                                {!!mTable.step && <col width="90px" />}
                                <col width="100px" />
                                <col width="170px" />
                                <col />
                                {
                                    user.isAdmin && <col width="150px" />
                                }
                                
                            </colgroup>
                            <thead style={{ position: "sticky", zIndex: "10", top: "0" }}>
                                <tr>
                                    <th colSpan={fnThColSpan()}>Paramter IN</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th>Process</th>
                                    {!!mTable.uo && (
                                        <th data-type={"unitOpNm"} onClick={changeOrderby}>
                                            Unit Op.
                                            {OrderBy?.name === "unitOpNm" && (
                                                <>
                                                    &nbsp;
                                                    {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                                </>
                                            )}
                                        </th>
                                    )}
                                    {!!mTable.step && (
                                        <th data-type={"stepNm"} onClick={changeOrderby}>
                                            Step Op.
                                            {OrderBy?.name === "stepNm" && (
                                                <>
                                                    &nbsp;
                                                    {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                                </>
                                            )}
                                        </th>
                                    )}
                                    <th data-type={"paraCd"} onClick={changeOrderby}>
                                        Code
                                        {OrderBy?.name === "paraCd" && (
                                            <>
                                                &nbsp;
                                                {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                            </>
                                        )}
                                    </th>
                                    <th data-type={"paraNm"} onClick={changeOrderby}>
                                        Code Name
                                        {OrderBy?.name === "paraNm" && (
                                            <>
                                                &nbsp;
                                                {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                            </>
                                        )}
                                    </th>
                                    <th data-type={"paraDesc"} onClick={changeOrderby}>
                                        Description
                                        {OrderBy?.name === "paraDesc" && (
                                            <>
                                                &nbsp;
                                                {OrderBy?.type !== "DESC" ? <FontAwesomeIcon icon={faArrowUpWideShort} /> : <FontAwesomeIcon icon={faArrowDownWideShort} />}
                                            </>
                                        )}
                                    </th>
                                    {
                                        user.isAdmin && <th>
                                        {!!mTable.step ?
                                            (!!OrderBy?.name || Object.keys(Filter)?.filter((e) => !!Filter[e]).length > 0 ? (
                                                <button
                                                    className={`${style.reset}`}
                                                    onClick={() => {
                                                        SetOrderBy(null);
                                                        SetFilter(FilterInitial);
                                                    }}
                                                >
                                                    Reset
                                                </button>
                                            ) : (
                                                <button disabled={!MoveAble} className={`${style.order}`} onClick={setOrderBy}>
                                                    {t("ChangeOrder")}
                                                </button>
                                            )) : "Status"}
                                    </th>
                                    }
                                    
                                </tr>
                                <tr className={`${style.filter}`}>
                                    <td colSpan="2"></td>
                                    {!!mTable.uo && (
                                        <td>
                                            <input type="text" placeholder="Filter" value={Filter?.unitOpNm} onChange={(e) => SetFilter((T) => ({ ...T, unitOpNm: e.target.value }))} />
                                        </td>
                                    )}
                                    {!!mTable.step && (
                                        <td>
                                            <input type="text" placeholder="Filter" value={Filter?.stepNm} onChange={(e) => SetFilter((T) => ({ ...T, stepNm: e.target.value }))} />
                                        </td>
                                    )}
                                    <td>
                                        <input type="text" placeholder="Filter" value={Filter.paraCd} onChange={(e) => SetFilter((T) => ({ ...T, paraCd: e.target.value }))} />
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Filter" value={Filter.paraNm} onChange={(e) => SetFilter((T) => ({ ...T, paraNm: e.target.value }))} />
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Filter" value={Filter.paraDesc} onChange={(e) => SetFilter((T) => ({ ...T, paraDesc: e.target.value }))} />
                                    </td>
                                    {
                                        user.isAdmin && <td></td>
                                    }
                                    
                                </tr>
                            </thead>
                            <tbody>
                                
                                {renderTable}
                            </tbody>
                            {(!!mTable.step && user.isAdmin) && (
                                <tfoot style={{ position: "sticky", zIndex: "10", bottom: "0" }}>
                                    <tr>
                                        <td colSpan={thColSpan.current - 4}></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="paraCd"
                                                placeholder="Code"
                                                value={NewParam.paraCd}
                                                onChange={(e) => {
                                                    SetNewParam((p) => ({ ...p, paraCd: e.target.value }));
                                                }}
                                                maxLength='9'
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="paraNm"
                                                placeholder="Parameter Name"
                                                value={NewParam.paraNm}
                                                onChange={(e) => {
                                                    SetNewParam((p) => ({ ...p, paraNm: e.target.value }));
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="paraDesc"
                                                placeholder="Description"
                                                value={NewParam.paraDesc}
                                                onChange={(e) => {
                                                    SetNewParam((p) => ({ ...p, paraDesc: e.target.value }));
                                                }}
                                            />
                                        </td>
                                        <td className={`${style.textCenter}`}>
                                            <button className={`${style.tBtn} ${style.main}`} onClick={insertMasterCode}>
                                                {t("save")}
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            )}
                        </table>
                    </DndProvider>
                </div>

                {!!ModalOpen && <ModalPortal>{ModalRender}</ModalPortal>}
            </section>
        );
    }
};

export default React.forwardRef(ParaInTable);
